const font = {
    fontFamily: 'Open Sans, Arial, sans-serif',
    fontWeight: 400,
};

export const styles = {
    input: {
        position: 'absolute',
        height: 1,
        width: 1,
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        clip: 'rect(0 0 0 0)',
        clipPath: 'inset(50%)',
    },
    checkbox: {
        height: 16,
        width: 16,
        marginRight: 8,
        padding: 1,
        boxSizing: 'border-box',
        background: '#FFFFFF',
        border: '1px solid #3D95FB',
        borderRadius: 4,
        transition: 'all 0.3s',
    },
    checkboxActive: {
        background: '#3D95FB',
    },
    label: {
        marginBottom: 8,
        display: 'flex',
        ...font,
        fontSize: '14px',
        color: '#222222',
        cursor: 'pointer',
    },
    inputText: {
        display: 'flex',
        flexDirection: 'column',
        lineHeight: '100%',
    },
    caption: {
        marginTop: 2,
        fontSize: '10px',
        lineHeight: '16px',
        color: '#9B9B9B',
        ...font,
    },
};

export type ComponentJSSClasses = JSSClasses<typeof styles>;
